import { render, staticRenderFns } from "./ContactEdit.vue?vue&type=template&id=b172cdda&scoped=true"
import script from "./ContactEdit.vue?vue&type=script&lang=js"
export * from "./ContactEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b172cdda",
  null
  
)

export default component.exports